// Test page for email processing service
// Provides a comprehensive testing interface for N8N webhook integration

import React from 'react';
import { EmailProcessingTest } from '@/components/email/EmailProcessingTest';
import ErrorBoundary from '@/components/debug/ErrorBoundary';

export default function EmailProcessingTestPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="container mx-auto px-4">
        <ErrorBoundary>
          <EmailProcessingTest />
        </ErrorBoundary>
      </div>
    </div>
  );
}
